import { Select } from '@headlessui/react';

export interface FilterProps {
  onFilterChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  filterOptionAsString: (value: { active: boolean; inactive: boolean }) => string;
  filterOptions: { value: { active: boolean; inactive: boolean }; label: string }[];
  cyTag: string;
}

export const TableFilter = ({
  filterOptions,
  cyTag,
  onFilterChange,
  filterOptionAsString,
}: FilterProps) => {
  return (
    <Select
      data-cy={cyTag}
      onChange={onFilterChange}
      className={
        'bg-white border border-grey-800 rounded-md body-text py-2 px-3 text-grey-100 transition-colors duration-150 focus:border-primary-50 focus:ring-3 focus:ring-primary-50/12 focus:outline-none'
      }
    >
      {filterOptions.map((option, index) => (
        <option key={index} value={filterOptionAsString(option.value)}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};
